import { OrderDetailType } from '@schemas'

class OrderDetail {
	constructor({
		id = '',
		productId = '',
		quantity = 0,
		soldUsd = 0,
		productName = '',
		standardUsd = 0,
		seasonUsd = 0,
		seasonDiscountedUsd = 0,
		seasonActiveUsd = 0,
		deletedAt = '',
		unitAmount = null,
		optionAmount = 0,
		optionId = '',
		optionName = '',
		pricePhase = '',
	} = {}) {
		this.id = id === null ? '' : id
		this.productId = productId === null ? '' : productId
		this.quantity = quantity === null ? 0 : quantity
		this.soldUsd = soldUsd === null ? 0 : soldUsd
		this.productName = productName === null ? '' : productName
		this.standardUsd = standardUsd === null ? 0 : standardUsd
		this.seasonUsd = seasonUsd === null ? 0 : seasonUsd
		this.seasonDiscountedUsd = seasonDiscountedUsd === null ? 0 : seasonDiscountedUsd
		this.seasonActiveUsd = seasonActiveUsd === null ? 0 : seasonActiveUsd
		this.deletedAt = deletedAt === null ? '' : deletedAt
		this.unitAmount = unitAmount === null ? this.soldUsd : Number(unitAmount)
		this.optionAmount = optionAmount === null ? 0 : Number(optionAmount)
		this.optionId = optionId === null ? '' : optionId
		this.optionName = optionName === null ? '' : optionName
		this.pricePhase = pricePhase === null ? '' : pricePhase
	}

	id: string
	productId: string
	quantity: number
	soldUsd: number
	unitAmount: number
	optionAmount: number
	optionId: string
	optionName: string
	pricePhase: string
	productName: string
	standardUsd: number
	seasonUsd: number
	seasonDiscountedUsd: number
	seasonActiveUsd: number
	deletedAt: string
}

class Order {
	constructor({
		id = '',
		seasonId = '',
		customerId = '',
		customerEmail = '',
		couponId = '',
		couponCode = '',
		couponDiscountUsd = 0,
		boxType = '',
		deliveryCompany = '',
		trackingNumber = '',
		shippingRateType = '',
		deliveryCompletedAt = '',
		receiverGivenName = '',
		receiverFamilyName = '',
		phoneCountryNumber = '',
		phoneNumber = '',
		address1 = '',
		address2 = '',
		city = '',
		state = '',
		stateIsoCode = '',
		zip = '',
		country = '',
		countryCode = '',
		totalUsd = 0,
		vatUsd = 0,
		shippingUsd = 0,
		discountedUsd = 0,
		paidUsd = 0,
		currency = 'USD',
		totalAmount = null,
		discountAmount = null,
		shippingAmount = null,
		paidAmount = null,
		channel = 'retail',
		paidYn = 1,
		paidAt = '',
		vatAmount = null,
		dutyAmount = null,
		shippingCost = null,
		dutyCost = null,
		paymentMethod = '',
		gatewayRef = '',
		paypalCaptureId = '',
		holdExpiresAt = '',
		refundAmount = 0,
		refundRef = '',
		refundReason = '',
		refundOverrideYn = 0,
		invoiceNumber = '',
		invoiceUrl = '',
		status = 'new',
		createdAt = '',
		deletedAt = '',
		deletedBy = '',
		deleteReason = '',
		updatedAt = '',
		updatedBy = '',
		preparedAt = '',
		refundedBy = '',
		refundedByName = '',
		refundedByEmail = '',
		refundedAt = '',
		updatedByName = '',
		updatedByEmail = '',
		deletedByName = '',
		deletedByEmail = '',
		detailList = [],
		hasPreorderLine = false,
		fulfillmentStage = '',
		fulfillmentDates = {},
	} = {}) {
		this.id = id === null ? '' : id
		this.seasonId = seasonId === null ? '' : seasonId
		this.customerId = customerId === null ? '' : customerId
		this.customerEmail = customerEmail === null ? '' : customerEmail
		this.couponId = couponId === null ? '' : couponId
		this.couponCode = couponCode === null ? '' : couponCode
		this.couponDiscountUsd = couponDiscountUsd === null ? 0 : couponDiscountUsd
		this.boxType = boxType === null ? '' : boxType
		this.deliveryCompany = deliveryCompany === null ? '' : deliveryCompany
		this.trackingNumber = trackingNumber === null ? '' : trackingNumber
		this.shippingRateType = shippingRateType === null ? '' : shippingRateType
		this.deliveryCompletedAt = deliveryCompletedAt === null ? '' : deliveryCompletedAt
		this.receiverGivenName = receiverGivenName === null ? '' : receiverGivenName
		this.receiverFamilyName = receiverFamilyName === null ? '' : receiverFamilyName
		this.phoneCountryNumber = phoneCountryNumber === null ? '' : phoneCountryNumber
		this.phoneNumber = phoneNumber === null ? '' : phoneNumber
		this.address1 = address1 === null ? '' : address1
		this.address2 = address2 === null ? '' : address2
		this.city = city === null ? '' : city
		this.state = state === null ? '' : state
		this.stateIsoCode = stateIsoCode === null ? '' : stateIsoCode
		this.state = state === null ? '' : state
		this.zip = zip === null ? '' : zip
		this.country = country === null ? '' : country
		this.countryCode = countryCode === null ? '' : countryCode
		this.totalUsd = totalUsd === null ? 0 : totalUsd
		this.vatUsd = vatUsd === null ? 0 : vatUsd
		this.shippingUsd = shippingUsd === null ? 0 : shippingUsd
		this.discountedUsd = discountedUsd === null ? 0 : discountedUsd
		this.paidUsd = paidUsd === null ? 0 : paidUsd
		// 실제 청구 통화·금액. 옛 주문(값 없음)은 USD 컬럼으로 되살린다
		this.currency = currency === null || currency === '' ? 'USD' : currency
		this.paidAmount = paidAmount === null ? this.paidUsd : Number(paidAmount)
		this.shippingAmount =
			shippingAmount === null ? this.shippingUsd : Number(shippingAmount)
		this.discountAmount =
			discountAmount === null ? this.discountedUsd : Number(discountAmount)
		this.totalAmount =
			totalAmount === null
				? Math.round((this.paidUsd - this.shippingUsd + this.discountedUsd) * 100) / 100
				: Number(totalAmount)
		this.paymentMethod = paymentMethod === null ? '' : paymentMethod
		// 채널·도매 금액 (DISPATCH_PLAN §4.6·§5). 옛 주문은 retail / 0
		this.channel = channel === null || channel === '' ? 'retail' : channel
		this.paidYn = paidYn === null || paidYn === undefined ? 1 : Number(paidYn)
		this.paidAt = paidAt === null ? '' : paidAt
		this.vatAmount = vatAmount === null ? 0 : Number(vatAmount)
		this.dutyAmount = dutyAmount === null ? 0 : Number(dutyAmount)
		this.shippingCost = shippingCost === null ? null : Number(shippingCost)
		this.dutyCost = dutyCost === null ? null : Number(dutyCost)
		this.gatewayRef = gatewayRef === null ? '' : gatewayRef
		this.paypalCaptureId = paypalCaptureId === null ? '' : paypalCaptureId
		this.holdExpiresAt = holdExpiresAt === null ? '' : holdExpiresAt
		this.refundAmount = refundAmount === null ? 0 : Number(refundAmount)
		this.refundRef = refundRef === null ? '' : refundRef
		this.refundReason = refundReason === null ? '' : refundReason
		this.refundOverrideYn = refundOverrideYn === null ? 0 : Number(refundOverrideYn)
		this.invoiceNumber = invoiceNumber === '' ? '' : invoiceNumber
		this.invoiceUrl = invoiceUrl === '' ? '' : invoiceUrl
		this.status = status === null ? 'new' : status
		this.createdAt = createdAt === null ? '' : createdAt
		this.deletedAt = deletedAt === null ? '' : deletedAt
		this.deletedBy = deletedBy === null ? '' : deletedBy
		this.deleteReason = deleteReason === null ? '' : deleteReason
		this.updatedAt = updatedAt === null ? '' : updatedAt
		this.updatedBy = updatedBy === null ? '' : updatedBy
		this.preparedAt = preparedAt === null ? '' : preparedAt
		this.refundedBy = refundedBy === null ? '' : refundedBy
		this.refundedAt = refundedAt === null ? '' : refundedAt
		// 이력에 보일 사람. 서버가 USERS 를 조인해 준다 — 고객이 만든 주문에는 비어 있다
		this.refundedByName = refundedByName === null ? '' : refundedByName
		this.refundedByEmail = refundedByEmail === null ? '' : refundedByEmail
		this.updatedByName = updatedByName === null ? '' : updatedByName
		this.updatedByEmail = updatedByEmail === null ? '' : updatedByEmail
		this.deletedByName = deletedByName === null ? '' : deletedByName
		this.deletedByEmail = deletedByEmail === null ? '' : deletedByEmail
		this.detailList = detailList.map(aDetail => new OrderDetail(aDetail))
		// 프리오더 이행 단계 — 서버가 줄에서 접어 준다 (ORDER_PLAN §3.1)
		this.hasPreorderLine = hasPreorderLine === true
		this.fulfillmentStage = fulfillmentStage === null ? '' : fulfillmentStage
		this.fulfillmentDates = fulfillmentDates === null ? {} : fulfillmentDates
	}
	id: string
	seasonId: string
	customerId: string
	customerEmail: string
	couponId: string
	couponCode: string
	couponDiscountUsd: number
	boxType: string
	deliveryCompany: string
	trackingNumber: string
	shippingRateType: string
	deliveryCompletedAt: string
	receiverGivenName: string
	receiverFamilyName: string
	phoneCountryNumber: string
	phoneNumber: string
	address1: string
	address2: string
	city: string
	state: string
	stateIsoCode: string
	zip: string
	country: string
	countryCode: string
	totalUsd: number
	vatUsd: number
	shippingUsd: number
	discountedUsd: number
	paidUsd: number
	currency: string
	totalAmount: number
	discountAmount: number
	shippingAmount: number
	paidAmount: number
	paymentMethod: string
	channel: string
	/** 도매 주문의 입금 여부. 입금 전에도 주문확인·배송은 진행된다(2026-09-27) */
	paidYn: number
	paidAt: string
	vatAmount: number
	dutyAmount: number
	shippingCost: number | null
	dutyCost: number | null
	gatewayRef: string
	paypalCaptureId: string
	holdExpiresAt: string
	refundAmount: number
	refundRef: string
	refundReason: string
	refundOverrideYn: number
	invoiceNumber: string
	invoiceUrl: string
	status: string // new | preparing | inTransit | completed | deleted | refunded
	createdAt: string
	deletedAt: string
	deletedBy: string
	deleteReason: string
	updatedAt: string
	updatedBy: string
	preparedAt: string
	refundedBy: string
	refundedByName: string
	refundedByEmail: string
	updatedByName: string
	updatedByEmail: string
	deletedByName: string
	deletedByEmail: string
	refundedAt: string
	detailList: OrderDetailType[]
	hasPreorderLine: boolean
	fulfillmentStage: string
	fulfillmentDates: { [stage: string]: string }
}

export { Order }
